// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 新建自选股分组 POST /my-stock/group/add */
export async function myStockGroupAddUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.myStockGroupAddUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/my-stock/group/add', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取自选股分组列表 GET /my-stock/group/list */
export async function myStockGroupListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.myStockGroupListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListMyStockGroupResp>('/my-stock/group/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 删除自选股分组 POST /my-stock/group/remove */
export async function myStockGroupRemoveUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.myStockGroupRemoveUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/my-stock/group/remove', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 修改自选股分组名称 POST /my-stock/group/rename */
export async function myStockGroupRenameUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.myStockGroupRenameUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/my-stock/group/rename', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 排序自选股分组 POST /my-stock/group/sort */
export async function myStockGroupSortUsingPOST(
  body: API.StockGroupSortReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/my-stock/group/sort', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 添加自选股 POST /my-stock/stock/add */
export async function myStockStockAddUsingPOST(
  body: API.MyStockAddReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/my-stock/stock/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取默认分组自选股列表 GET /my-stock/stock/default-list */
export async function myStockStockDefaultListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultMyStockResp>('/my-stock/stock/default-list', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 编辑自选股 POST /my-stock/stock/edit */
export async function myStockStockEditUsingPOST(
  body: API.MyStockSortReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/my-stock/stock/edit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询用户股票是否添加自选股 GET /my-stock/stock/is-add */
export async function myStockStockIsAddUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.myStockStockIsAddUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultboolean>('/my-stock/stock/is-add', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取自选股列表 GET /my-stock/stock/list */
export async function myStockStockListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.myStockStockListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultMyStockResp>('/my-stock/stock/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 删除自选股 POST /my-stock/stock/remove */
export async function myStockStockRemoveUsingPOST(
  body: API.MyStockSortReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/my-stock/stock/remove', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
